module.exports = __webpack_public_path__ + "static/img/soul-journey-home-default.1303eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/soul-journey-home-default.png
// module id = c2mh
// module chunks = 0